import './ModalContainer.scss';
import React from 'react';
import { Dialog } from "primereact/dialog";
import classNames from 'classnames';

function ModalContainer(props) {
  const { children, visible, className, ...restProps } = props

  return (
      <Dialog visible={visible} {...restProps} appendTo='self' className={classNames('ModalContainer', className)}>
        {children}
      </Dialog>
  )
}

ModalContainer.defaultProps = {
  visible: false
}

export default ModalContainer;
